import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IconCardConfig } from 'src/app/interfaces/pageConfig';
import { ProductType } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { LogService } from 'src/app/services/common/log.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { MemberShipOptionsService } from 'src/app/services/membership-options/membership-options.service';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';
import { IdentialertSubSelectionModalComponent } from '../identialert-sub-selection-modal/identialert-sub-selection-modal.component';

@Component({
  selector: 'app-identialert-v2',
  templateUrl: './identialert-v2.component.html',
  styleUrl: './identialert-v2.component.scss'
})
export class IdentialertV2Component implements OnInit {

  pricingPlans = environment.stripePlans;
  trustTitle: string;
  trustSubtitle: string;
  plan1ShowUpCards: IconCardConfig[];

  // True (enabled) until a signed-in user's current plan says otherwise.
  public identiAlertAvailable = true;
  // Null when the backend offers Alert yearly-only, which skips the billing-interval modal.
  public plan2MonthlyPrice: string;

  private plan2Route: string;

  private isUpgrade: boolean;

    constructor(
    private configService: ConfigService,
    private authManager: AuthManagerService,
    private _checkoutService: CheckoutService,
    private _logService: LogService,
    private membershipOptionsService: MemberShipOptionsService,
    private userService: UserService,
    private paymentConfigService: PaymentConfigService,
    private modalService: NgbModal,
    private _router: Router,
  ) {

    this.plan1ShowUpCards = this.configService.getObjectListFromKey<IconCardConfig>('2-plan-showUpCards');
    this.trustTitle = this.configService.getTextFromKey('trust-title');
    this.trustSubtitle = this.configService.getTextFromKey('trust-subtitle');
    this.plan2Route = this.configService.getTextFromKey('2-plan-route');
    this.plan2MonthlyPrice = this.paymentConfigService.getMonthlyDisplayPrice(
      ProductType.Premium,
      this.configService.getTextFromKey('2-plan-monthly-price')
    );
  }

  ngOnInit(): void {
    if (!this.authManager.isAuthenticated) return;

    this.userService.getMe().subscribe((user) => {
      this.identiAlertAvailable = this.membershipOptionsService.identiAlertAvailable(user);
      this.isUpgrade = user.productType === ProductType.Basic;
    });
  }

  /**
   * Both page CTAs land here. Alert is the only plan with a billing-interval choice, so it opens
   * the selection modal instead of checking out directly. When the backend offers no monthly price
   * the modal would hold a single option, so we fall through to the annual checkout.
   */
  public buyIdentialertSubscription() {
    // Checkout needs a session, and signed out the prices come from config rather than /payment,
    // so log in first and come back to this page.
    if (!this.authManager.isAuthenticated) {
      this._router.navigate(['/login-register'], { queryParams: { r: this.plan2Route } });
      return;
    }

    if (!this.plan2MonthlyPrice) {
      this.buyIdentialertAnnualSubscription();
      return;
    }

    const modalRef = this.modalService.open(IdentialertSubSelectionModalComponent, {
      backdrop: 'static',
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.modalRef = modalRef;
    modalRef.componentInstance.isUpgrade = this.isUpgrade;
  }

  private buyIdentialertAnnualSubscription() {
    const planId = this.pricingPlans.identiAlertAnnual;
    this._checkoutService.checkout([planId], { isUpgrade: this.isUpgrade }).subscribe({
      next: () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      error: (err) => {
        this._logService.error('an error occured: ', err);
      }
    });
  }

}
